import { Checkbox, ChoiceRow, Field, FieldGrid, Input, Select } from '@westhetics/ui'
import { useMemo } from 'react'
import { touchField } from '@/app/public-screen'
import { maskCpf } from '@/lib/masks'
import { countryOptions, FOREIGN_DOCUMENT_TYPE_LABELS } from '../register/labels'
import type { DocumentErrors, DocumentValues } from './document'

/** O documento para entrar: o CPF, ou, com "Não tenho CPF", o estrangeiro (RN-POR-19, RN-PAC-04). */
export function DocumentFields({
  values,
  onChange,
  errors,
  idPrefix,
}: {
  values: DocumentValues
  onChange: (values: DocumentValues) => void
  errors: DocumentErrors
  idPrefix: string
}) {
  const countries = useMemo(() => (values.hasNoCpf ? countryOptions() : []), [values.hasNoCpf])
  const set = <K extends keyof DocumentValues>(key: K, value: DocumentValues[K]) =>
    onChange({ ...values, [key]: value })
  return (
    <>
      <FieldGrid className="mt-7">
        {values.hasNoCpf ? (
          <>
            <Field id={`${idPrefix}-foreignType`} label="Tipo de documento">
              <Select
                value={values.foreignType}
                className={touchField}
                onChange={(event) =>
                  set('foreignType', event.target.value as DocumentValues['foreignType'])
                }
              >
                {Object.entries(FOREIGN_DOCUMENT_TYPE_LABELS).map(([value, label]) => (
                  <option key={value} value={value}>
                    {label}
                  </option>
                ))}
              </Select>
            </Field>
            <Field
              id={`${idPrefix}-foreignNumber`}
              label="Número do documento"
              error={errors.foreignNumber}
            >
              <Input
                value={values.foreignNumber}
                className={touchField}
                autoComplete="off"
                autoCapitalize="characters"
                maxLength={20}
                onChange={(event) => set('foreignNumber', event.target.value)}
              />
            </Field>
            <Field
              id={`${idPrefix}-foreignCountry`}
              label="País que emitiu"
              error={errors.foreignCountry}
              className="tablet:col-span-2"
            >
              <Select
                value={values.foreignCountry}
                className={touchField}
                placeholder="Escolha o país"
                onChange={(event) => set('foreignCountry', event.target.value)}
              >
                {countries.map((country) => (
                  <option key={country.code} value={country.code}>
                    {country.name}
                  </option>
                ))}
              </Select>
            </Field>
          </>
        ) : (
          <Field
            id={`${idPrefix}-docNumber`}
            label="CPF"
            error={errors.docNumber}
            className="tablet:col-span-2"
          >
            <Input
              value={values.docNumber}
              className={touchField}
              inputMode="numeric"
              autoComplete="off"
              placeholder="000.000.000-00"
              maxLength={14}
              onChange={(event) => set('docNumber', maskCpf(event.target.value))}
            />
          </Field>
        )}
      </FieldGrid>
      <ChoiceRow
        className="mt-4"
        control={
          <Checkbox
            checked={values.hasNoCpf}
            onCheckedChange={(checked) => set('hasNoCpf', checked === true)}
          />
        }
        description="Passaporte, RNE ou CRNM, como está no seu cadastro na clínica."
      >
        Não tenho CPF
      </ChoiceRow>
    </>
  )
}
